import { createAction, props } from '@ngrx/store';

export const trackedKilkaya = createAction(
  '[Page View] Pushed Kilkaya Event',
  props<{ payload: { explicitlySetMeta: { [key: string]: any } } }>()
);
